import React from 'react';

import { Gap, Placeholder } from '@common/components';

export function DrawerLoadingSkeleton() {
  return (
    <Gap
      vertical
      size="lg"
      className="wk-drawer-loading-skeleton"
      dataTestId="wk-drawer-loading-skeleton"
    >
      <Placeholder.Input loading size="small" width={390}>
        <div />
      </Placeholder.Input>

      <Placeholder
        loading
        paragraph={{ rows: 3, width: ['100%', '95%', '75%'] }}
      >
        <div />
      </Placeholder>

      <Gap vertical size="lg">
        <Placeholder.Input loading size="small" width={120}>
          <div />
        </Placeholder.Input>
        <Placeholder.Input loading size="large" width={340}>
          <div />
        </Placeholder.Input>
      </Gap>

      <Gap vertical size="lg">
        <Placeholder.Input loading size="small" width={140}>
          <div />
        </Placeholder.Input>
        <Placeholder.Input loading size="large" width={450}>
          <div />
        </Placeholder.Input>
      </Gap>

      <Placeholder.Input loading size="default" width={240}>
        <div />
      </Placeholder.Input>
    </Gap>
  );
}
